module.exports = __webpack_public_path__ + "img/heroill.3cbcee3a.svg";